import * as Sentry from "@sentry/nextjs";
import { ErrorBoundaryProps as SentryErrorBoundaryProps } from "@sentry/react";

export default Sentry;
export type { SentryErrorBoundaryProps };
